import * as React from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
import toast from 'react-hot-toast';
import { postRequest } from '../../../../lib/api';
import { useContext } from 'react';
import { AuthContext } from '../../../../authContext/context';
import Swal from 'sweetalert2'; 
import BreadcrumbsWrapper from '../../../../components/breadcrumbs'
import { checkPermission } from '../../../../utils/checkPermissions';
import { Typography } from '@mui/material';

// Redux imports
import { useDispatch } from 'react-redux';


export default function CreateApikey() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset
  } = useForm();

  const navigate = useNavigate();
  const authCtx = useContext(AuthContext);
  const [loading, setLoading] = React.useState(false);
  const userPermissions = authCtx.permissions;

  const dispatch = useDispatch();

  // Check if user has permission to create API keys
  const canCreateAPIKeys = checkPermission(userPermissions, 'api', 'create_api_keys');

 const onSubmit = async (data) => {
  setLoading(true);
  try {
    const payload = {
      title: data?.title,
    };
    const response = await postRequest('private/createApiKey', payload, authCtx.token);
    console.log(response, 'response');
    if (response?.status == 200) {
      reset();

 
      await Swal.fire({
        title: 'API Key Created',
        html: `
          <p>Please copy this key and save it somewhere safe.</p>
          <p style="color:red;">For security reasons, we cannot show it to you again.</p>
          <div style="padding: 10px; background-color: #f1f1f1; border-radius: 4px; word-break: break-all;">
            ${response?.data?.key || 'N/A'}
          </div>
        `,
        icon: 'success',
        confirmButtonText: 'Done',
        confirmButtonColor: '#bb0000',
        width: 600,
      });

      //toast.success('Api key created successfully ');
      navigate('/apiKeys');
    } else {
      //toast.error(response?.message || 'Api key creation failed');
    }
  } catch (err) {
    //toast.error(err?.message || 'Something went wrong');
  } finally {
    setLoading(false);
  }
};

  // Check if user has permission to create API keys
  if (!canCreateAPIKeys) {
    return (
      <>
        <BreadcrumbsWrapper
          items={[
            { label: 'Dashboard', path: '/dashboard' },
            { label: 'ApiKeys', path: '/apiKeys' },
            { label: 'CreateApiKey', path: '' },
          ]}
        />
        <br></br>
        <div className='page-header pb-3'>
          <h1 className='mt-0 mb-0'>Add New Api Key</h1>
        </div>
        <div className='page-top-formview mb-3 text-center'>
          <Typography variant="h6" color="text.secondary">
            You do not have permission to create API keys.
          </Typography>
        </div>
      </>
    );
  }

  return (
    <>
      <BreadcrumbsWrapper
                                                items={[
                                                  { label: 'Dashboard', path: '/dashboard' },
                                                  { label: 'ApiKeys', path: '/apiKeys' },
                                                  { label: 'CreateApiKey', path: '' },
                                                
                                                 
                                                ]}
                                              />
                                        <br></br>
      <div className="page-header">
        <h1 className="mt-0">Add New Api Key</h1>
      </div>

      <div className="page-top-formview mb-3">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row className="mb-3">
            <Form.Group as={Col} controlId="title">
              <Form.Label>Title</Form.Label>
              <Form.Control
                type="text"
                placeholder="Title of api key"
                {...register('title', { required: 'Title is required' })}
                isInvalid={!!errors.title}
              />
              <Form.Control.Feedback type="invalid">
                {errors.title?.message}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>

          <Stack direction="row" spacing={2}>
            <Button variant="outlined" color="inherit" type="button" onClick={() => navigate('/apiKeys')}>
              Cancel
            </Button>
            <Button variant="contained" className='red-bg red-button text-capitalize' type="submit" disabled={loading}>
              {loading ? <CircularProgress size={20} color="inherit" /> : 'Submit'}
            </Button>
          </Stack>
        </Form>
      </div>
    </>
  );
}